/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import imgs from '../../../assets/images/no.png'
import com from '../../../assets/images/complete.png'
import '../../../assets/styles/ChannelList.css'
import { Link, useParams, useNavigate } from 'react-router-dom'
import moment from 'moment';
import { DELETE, GET, POST } from '../../../helpers/httphelper';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import noimage from '../../../assets/images/noimage.png'
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
function ViewChanneling(props) {
    const params = useParams()
    const navigate = useNavigate()
    const [channeling, setChanneling] = useState()
    const [ldate, setldate] = useState('')
    const [lname, setlname] = useState('')
    const [FileUrl, setFileUrl] = useState('')
    const [Progress, setProgress] = useState(0)
    const [onelab, setonelab] = useState()
    const cid = params.id
    useEffect(() => {
        setdata()
    }, [])

    const setdata = () => {
        GET(`api/channeling/get/${cid}`).then(data => {
            setChanneling(data)
        }).catch(err => {
            console.log(err)
        })
    }
    const checkDate = (date, time) => {
        var selectDate = moment(date, "YYYY-MM-DD")
        var todayDate = moment().startOf('day')
        var days = moment.duration(selectDate.diff(todayDate)).asDays()
        if (days < 0) {

            return false
        }
        else if (days === 0) {
            return checkTime(time)
        }
        else {

            return true
        }
    }

    const checkTime = (time) => {

        const selectTime = moment(time, "HH:mm")
        const todayTime = moment().startOf('minute')
        const mins = moment.duration(selectTime.diff(todayTime)).asMinutes()
        if (mins < 0) {

            return false
        }
        else {

            return true
        }

    }

    const uploadImage = (e) => {
        e.preventDefault()
        const file = e.target.files[0]
        if (!file) {
            return
        }
        const storageRef = ref(storage, `/channelings/${file.name}`); //get file reference
        const uploadTask = uploadBytesResumable(storageRef, file); //upload file

        uploadTask.on("state_changed", (snapshot) => { //listen for state changes
            const prog = Math.round( //get progress percentage
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100 //calculate progress percentage
            ); //end get progress percentage
            setProgress(prog); //set progress
        }, (err) => {
            console.log(err);
        }, () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                setFileUrl(url);
                console.log(url);
            })
        })

    }

    const showmodal = () => {
        document.getElementById("modal").classList.add("is-active")
    }

    const closemodal = () => {
        document.getElementById("modal").classList.remove("is-active")
    }

    const showOnemodal = (m) => {
        setonelab(m)
        document.getElementById("modal2").classList.add("is-active")
    }

    const hideOnemodal = () => {
        document.getElementById("modal2").classList.remove("is-active")
    }

    const showdeleteModal = () => {
        document.getElementById("modal3").classList.add("is-active")
    }

    const hidedeleteModal = () => {
        document.getElementById("modal3").classList.remove("is-active")
    }
    const sendData = (e) => {
        e.preventDefault()
        const ob = {
            name: lname,
            date: ldate,
            report: FileUrl
        }

        POST(`api/channeling/addtest/${cid}`, ob).then(data => {
            console.log(data)
            closemodal()
            setdata()
        }).catch(err => {
            console.log(err)
        })
    }

    const deleteChanneling = () => {
        DELETE(`api/channeling/delete/${cid}`).then(data => {
            console.log(data)
            navigate("../channeling")
        }).catch(err => {
            console.log(err)
        })
    }

    const generateReport = () => {
        const doc = new jsPDF()
        doc.text(90, 10, channeling.reason);
        autoTable(doc, {
            head: [['', '']],
            body: [["Date", moment(channeling?.date).format("YYYY-MM-DD")], ["Time", channeling.time]
                , ["Doctor Name", channeling.doctorName], ["Visiting City", channeling.visitCity],
            ["Reason", channeling.reason], ["FeedBack", channeling.feedback]
            ]
        })
        doc.save(channeling.reason + '.pdf')
    }

    return (
        <div className='container'>
            <Link to="../channeling"><h1 className='has-text-left mt-3'><i class="fas fa-arrow-circle-left"></i></h1></Link>
            <div className='columns is-justify-content-center'>
                <h1 className='title is-2  has-text-centered'>{channeling?.reason}</h1>

            </div>
            <div className='columns is-justify-content-center  is-mobile is-multiline'>
                <div className='column is-5-desktop is-8-tablet is-10-mobile'>
                    <div className='columns is-justify-content-center is-mobile'>
                        <div className='column is-8-desktop is-8-tablet is-8-mobile'>
                            <img src={channeling?.pimage ? channeling.pimage : imgs} className="mb-0 imgs" alt='' />
                        </div>
                    </div>

                    <div className='box lab-box'>
                        <div className='columns  is-mobile'>
                            <div className='column is-4'>
                                <button class="button is-info is-small is-rounded modal-button" onClick={(e) => { showmodal() }} data-target="#modal">
                                    <span class="icon">
                                        <i class="fas fa-plus-circle"></i>
                                    </span>
                                    <span>Add New Test</span>
                                </button>

                            </div>
                            <div className='column is-6'>
                                <h1 className='title is-5 has-text-centered'>Lab Tests</h1>
                            </div>
                        </div>
                        <div className='columns table-container'>
                            <table className='table is-striped is-hoverable is-fullwidth'>
                                <tbody>
                                    {channeling?.labtests?.map((m, i) => (
                                        <tr key={i}>
                                            <td>{(i + 1)}</td>
                                            <td>{m?.name}</td>
                                            <td>{moment(m?.date).format("YYYY-MM-DD")}</td>
                                            <td><button className='button is-warning is-rounded is-small' onClick={(e) => { showOnemodal(m) }}>View</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <div className='column is-6-desktop is-8-tablet is-10-mobile mt-4'>
                    <div className='columns is-mobile'>
                        <div className='column is-10-desktop is-10-tablet is-11-mobile mx-3'>
                            <div className='box'>
                                <div className='columns is-mobile'>
                                    <div className='column is-4'>
                                        <h1 className='sub-title'>Date</h1>
                                    </div>
                                    <div className='column is-6-desktop is-6-tablet is-8-mobile details'>
                                        <h1>{moment(channeling?.date).format("YYYY-MM-DD")}</h1>
                                    </div>
                                </div>
                                <div className='columns is-mobile'>
                                    <div className='column is-4'>
                                        <h1 className='sub-title'>Time</h1>
                                    </div>
                                    <div className='column is-6-desktop is-6-tablet is-8-mobile details'>
                                        <h1>{channeling?.time}</h1>
                                    </div>
                                </div>

                                <div className='columns is-mobile'>
                                    <div className='column is-4'>
                                        <h1 className='sub-title'>Doctor Name</h1>
                                    </div>
                                    <div className='column is-6-desktop is-6-tablet is-8-mobile details'>
                                        <h1>{channeling?.doctorName}</h1>
                                    </div>
                                </div>

                                <div className='columns is-mobile'>
                                    <div className='column is-4'>
                                        <h1 className='sub-title'>Status</h1>
                                    </div>
                                    <div className='column is-6-desktop is-6-tablet is-8-mobile details'>

                                        {
                                            checkDate(moment(channeling?.date).format("YYYY-MM-DD"), channeling?.time) ? <>
                                                <span className='tag is-link '>Yet to Visit</span>
                                            </> : <>
                                                <span className='tag is-success'>Completed</span>
                                            </>
                                        }
                                    </div>
                                </div>

                                <div className='columns is-mobile'>
                                    <div className='column is-4'>
                                        <h1 className='sub-title'>Feedback</h1>
                                    </div>
                                    <div className='column is-6-desktop is-6-tablet is-8-mobile details'>
                                        <h1>{channeling?.feedback === '' ? (<span className='tag is-link '>Not yet added</span>) : channeling?.feedback}</h1>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='columns mt-6 is-mobile is-multiline is-justify-content-center'>
                        <div className='column is-3-desktop is-4-tablet'>
                            <Link to={`../updatechanneling/${cid}`}>
                                <button class="button is-success  is-rounded ">
                                    <span class="icon">
                                        <i class="far fa-edit"></i>
                                    </span>
                                    <span>Update</span>
                                </button>
                            </Link>
                        </div>

                        <div className='column is-3-desktop is-4-tablet'>
                            <button class="button is-danger is-rounded" onClick={(e) => { showdeleteModal() }}>
                                <span class="icon">
                                    <i class="far fa-trash-alt"></i>
                                </span>
                                <span>Delete</span>
                            </button>
                        </div>
                        <div className='column is-3-desktop is-4-tablet'>
                            <Link to={`/medicines/channeling/${channeling?.reason}`}>
                                <button class="button is-primary is-rounded">
                                    <span class="icon">
                                        <i class="far fa-capsules"></i>
                                    </span>
                                    <span>Medicines</span>
                                </button>
                            </Link>
                        </div>
                        <div className='column is-3-desktop is-4-tablet'>
                            <button class="button is-link is-rounded" onClick={(e) => { generateReport() }}>
                                <span class="icon">
                                    <i class="far fa-file-pdf"></i>
                                </span>
                                <span>Report</span>
                            </button>
                        </div>
                    </div>
                </div>

            </div>


            <div class="modal" id="modal">
                <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head has-background-info">
                        <p class="modal-card-title has-text-centered" style={{ color: "white" }}>Add Lab Test</p>
                        <button class="delete" onClick={(e) => { closemodal() }} aria-label="close"></button>
                    </header>
                    <section class="modal-card-body">
                        <form onSubmit={sendData}>
                            <div className='columns is-justify-content-space-between is-align-items-center'>
                                <div className='column is-6'>
                                    <div className="field">
                                        <label className="label">Lab Test Date</label>
                                        <div className="control">
                                            <input required onChange={(e) => { setldate(e.target.value) }} className="input is-info" type="date" />
                                        </div>
                                    </div>

                                    <div className="field">
                                        <label className="label">Test Name</label>
                                        <div className="control">
                                            <input required onChange={(e) => { setlname(e.target.value) }} className="input is-info" type="text" placeholder='Test Name' />
                                        </div>
                                    </div>

                                    <div className="field">
                                        <label className="label">Test Report</label>
                                        <div className="control">
                                            <input required className="input is-info" onChange={(e) => { uploadImage(e) }} type="file" placeholder='Test Name' />
                                        </div>
                                        <div className="progressText">
                                            <progress style={{ height: '4px' }} className="progress is-success" value={Progress} max="100">{Progress}</progress>
                                        </div>
                                    </div>
                                </div>
                                <div className='column is-4'>
                                    <img src={FileUrl === '' ? noimage : com} alt='' />
                                </div>

                            </div>

                            <h1 className='has-text-centered'><input className='button is-primary' value='Add' type='submit' /></h1>
                        </form>
                    </section>
                    {/* <footer class="modal-card-foot">
                        <button class="button is-success has-text-centered">Save changes</button>
                    </footer> */}
                </div>
            </div>


            <div className="modal" id="modal2">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-background-success">
                        <p className="modal-card-title has-text-centered" style={{ color: "white" }}>{onelab?.name}</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hideOnemodal() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className='columns is-justify-content-space-between'>
                            <div className='column is-5'>
                                <div className='columns is-justify-content-center'>
                                    <div className='column is-6'>
                                        <a href={onelab?.report} className="button is-primary" target="blank">View Report</a>
                                    </div>
                                </div>

                            </div>
                            <div className='column is-5'>
                                <div className='columns mt-5'>
                                    <div className='column is-5'>
                                        <h1 className='title is-5'>Name</h1>
                                    </div>
                                    <div className='column is-7'>
                                        <h1>{onelab?.name}</h1>
                                    </div>
                                </div>
                                <div className='columns'>
                                    <div className='column is-5'>
                                        <h1 className='title is-5'>Date</h1>
                                    </div>
                                    <div className='column is-7'>
                                        <h1>{moment(onelab?.date).format("YYYY-MM-DD")}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </div>


            <div className="modal" id="modal3">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-background-danger">
                        <p className="modal-card-title has-text-centered" style={{ color: 'white' }}>Delete Channeling</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hidedeleteModal() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <h1 className='is-4 subtitle has-text-centered'>Sure You Want To Delete This Channeling ?</h1>
                        <h1 className='has-text-centered'>  <button className="button is-danger" onClick={(e) => { deleteChanneling() }}>Delete</button></h1>

                    </section>

                </div>
            </div>

        </div>
    );
}

export default ViewChanneling;